<div class="col-lg-12 hd1">
    <div class="col-lg-12">
        <div class="row">
            <div class="col-md-4">
                <div class="row">
                    <button class="btnWht"><a href="https://wa.me/573234902185" style="text-decoration: none;color: #fff;" target="_blank"><i class="fa fa-whatsapp fa-lg"></i></a></button>
                    <h5 class="hd ml-2"> WhatsApp 323 4902185</h5>
                </div>
            </div>
            <div class="col-lg-8 derecha">
              <a class="redes" href="https://www.facebook.com/torreonmarket.colombia" target="blank"><i class="fa fa-facebook fa-lg" aria-hidden="true"></i></a>
              <a class="redes" href="https://www.youtube.com/channel/UCMhrKPXZXlqmfUKSyXMIlsw" target="blank"><i class="fa fa-youtube fa-lg" aria-hidden="true"></i></a>
              <a class="redes" href="https://twitter.com/torreonmarket" target="blank"><i class="fa fa-twitter fa-lg" aria-hidden="true"></i></a>
              <a class="redes" href="https://www.instagram.com/torreon.market" target="blank"><i class="fa fa-instagram fa-lg" aria-hidden="true"></i></a>
            </div>
        </div>
    </div>
</div>
<nav class="navbar navbar-expand-lg navbar-light bg-light menmovil">
    <a class="navbar-brand" [routerLink]="['/home']">
        <img src="../../../assets/img/logo2.png" width="200" alt="" loading="lazy">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto">
            <li class="nav-item active">
                <a class="nav-link" [routerLink]="['/home']">Inicio <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/catalogo']">Productos</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/blog']">Blog</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/nosotros']">Nosotros</a>
            </li>
            <li class="nav-item dropdown hlp">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Ayuda
                </a>
                <div class="dropdown-menu dmnu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item dpitm" (click)="openHelp('pasos')">Pasos para Comprar</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item dpitm" (click)="openHelp('formas')">Formas de Pago</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item dpitm" (click)="openHelp('envios')">Envíos y Entregas</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item dpitm" (click)="openHelp('cuenta')">Mi Cuenta</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item dpitm" (click)="openHelp('preguntas')">Preguntas Frecuentes</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item dpitm" [routerLink]="['/terminos']">Términos y Condiciones</a>
                </div>
            </li>
            <li class="nav-item" *ngIf="user$ | async as user;">
                <a class="nav-link" routerLink="/info"><i class="fa fa-shopping-basket"></i> Mis compras</a>
            </li>
            <li class="nav-item" *ngIf="user$ | async as user;">
                <a class="nav-link" (click)="onLogout()"> <i class="fa fa-sign-out"></i> Salir</a>
            </li>
            <li class="nav-item" *ngIf="user$ | async as user;">
                <button class="carsec mr-5" [routerLink]="['/solicitudes']" routerLinkActive="router-link-active">
                    <i class="fa fa-shopping-cart fa-lg" aria-hidden="true"></i>
                    <span class="badge badge-warning intermitentesec">{{pedidos}}</span>
                </button>
            </li>
            <div class="user" *ngIf="user$ | async as user;else showLogin">
                <button class="btn btn-light btnSesion mt-2" data-toggle="modal" data-target="#sesion">{{user.email}}</button>
            </div>
            <ng-template #showLogin>
                <a data-toggle="modal" data-target="#myModal">
                    <button class="btn btn-light btnSesion mt-1">INGRESAR</button>
                </a>
            </ng-template>
        </ul>
    </div>
</nav>
<div id="myModal" class="modal fade">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-6 text-left">
                                    <h4><b>Inicio de Sesión</b></h4>
                                </div>
                                <div class="col-6 text-right">
                                    <img src="../../../assets/img/logo2.png" width="100" alt="">
                                </div>
                            </div>
                            <hr>
                            <div class="text-center">
                                <h5>Ingresa tu datos</h5>
                                <hr>
                            </div>
                            <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
                                <div class="form-group">
                                    <label for="email">E-mail:</label>
                                    <input type="email" class="form-control" placeholder="Ingrese su email" formControlName="email" [class.is-invalid]="emailNoValido">
                                    <small class="eml" *ngIf="emailNoValido">Ingrese un email válido</small>
                                </div>
                                <div class="form-group">
                                    <label for="email">Contraseña:</label>
                                    <div class="row" *ngIf="passwordView == false">
                                        <input type="password" class="form-control pass" formControlName="password" [class.is-invalid]="passwordNoValido">
                                        <button class="btn btn-light viewPass" (click)="viewPassActive()"><i class="fa fa-eye-slash fa-lg"></i></button>
                                        <small class="spn" *ngIf="passwordNoValido">La contraseña debe ser de 8 caracteres mínimo.</small>
                                    </div>
                                    <div class="row" *ngIf="passwordView == true">
                                        <input type="text" class="form-control pass" formControlName="password" [class.is-invalid]="passwordNoValido">
                                        <button class="btn btn-light viewPass" (click)="viewPassInActive()"><i class="fa fa-eye fa-lg"></i></button>
                                        <small class="spn" *ngIf="passwordNoValido">La contraseña debe ser de 8 caracteres mínimo.</small>
                                    </div>
                                </div>
                                <button type="submit" class="btn btn-dark btnIngreso "><i class="fa fa-sign-in" aria-hidden="true"></i> INGRESAR</button>
                                <button type="button" class="btn btn-outline-dark btnIngreso mt-2" [routerLink]="['/registro']" data-dismiss="modal"><i class="fa fa-user-circle" aria-hidden="true"></i> CREAR CUENTA</button>
                                <div class="col-12 text-center mt-2">
                                    <h5 style="color: #2f5496;cursor: pointer;" (click)="contrasena()" data-dismiss="modal">¿Olvidaste tu Contraseña?</h5>
                                </div>
                                <br><br>
                                <h5>Ingresa directamente con:</h5>
                                <hr>
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-6">
                                            <button type="button" class="btn btn-danger btn-block" (click)="onLoginGoogle()">
                                                <i class="fa fa-google fa-lg" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                        <div class="col-6">
                                            <button type="button" class="btn btn-primary btn-block" (click)="onLoginFacebook()">
                                                <i class="fa fa-facebook fa-lg" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="sesion" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" style="color:  #6C534C;">Sesión de Usuario</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <div class="col-12">
                    <div class="row">
                        <div class="col-6 text-center">
                            <img src="../../../assets/img/logout.png" alt="">
                            <br>
                            <br>
                            <button class="btn btn-dark btnIngreso" (click)="onLogout()" data-dismiss="modal" aria-label="Close">Cerrar Sesión</button>
                        </div>
                        <div class="col-6 text-center">
                            <img src="../../../assets/img/password.png" alt="">
                            <br>
                            <br>
                            <button class="btn btn-dark btnIngreso" (click)="contrasena()" data-dismiss="modal" aria-label="Close">Cambiar Contraseña</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
